import React from 'react';
import './Faq.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';

const Faq = () => {
    return (
        <section className='faq-section pt-100 pb-70'>
            <div className="container">
                <SectionTitle
                    subTitle="FAQ"
                    title="Frequently Asked Questions"
                    description="Find answers to common questions about TRUECARE Dental & Implant Center"
                />

                <div className="accordian-area">
                    <div class="accordion" id="accordionExample">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Is the dental check-up really free?
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Yes! We offer completely free dental check-ups with no hidden costs. This includes a comprehensive oral examination, X-ray consultation, treatment planning, and oral hygiene guidance. It's our way of making quality dental care accessible to everyone in Yamunanagar.
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                What dental plans do you offer?
                            </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    We offer several attractive plans: <strong>Smile Card (Family Plan)</strong> at ₹499/year for 4 members with 15% OFF on all treatments, <strong>Student Dental Health Card</strong> at ₹99 covering student + parents with free check-ups and brushing demonstrations, <strong>Free Dental Check-Up</strong> for everyone, and <strong>15% OFF on All Treatments</strong> including root canals, implants, cosmetic procedures, and orthodontic treatments.
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    What are your clinic timings and location?
                                </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    We are located at <strong>Shop No. 6, Sharma Garden, Near Mahindra Petrol Pump, Yamunanagar – 135001 (HR)</strong>. Our walk-in timings are: <strong>Morning:</strong> 10:00 a.m. – 1:30 p.m. and <strong>Evening:</strong> 5:30 p.m. – 7:30 p.m. You can also call us at <strong>6395947006</strong> for appointments or any queries.
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingFour">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    Who is Dr. Vinamrata and what are her qualifications?
                                </button>
                            </h2>
                            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Dr. Vinamrata is our expert MDS Specialist who completed her Master of Dental Surgery (MDS) from the prestigious Government Dental College, Ahmedabad. She brings years of expertise and specializes in providing comprehensive dental care using advanced equipment and maintaining the highest standards of hygiene. Her patient-first approach ensures comfortable and effective treatments.
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingFive">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    What dental services do you provide?
                                </button>
                            </h2>
                            <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    We offer a comprehensive range of dental services including: Root Canal Treatments, Dental Implants, Cosmetic Dentistry, Orthodontic Treatments (braces), Preventive Care, Teeth Cleaning & Whitening, Cavity Fillings, Gum Treatments, Wisdom Tooth Extraction, and Emergency Dental Care. All treatments are performed using state-of-the-art equipment in a sterilized environment.
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingSix">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    How can I book an appointment?
                                </button>
                            </h2>
                            <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Booking an appointment is easy! You can call us directly at <strong>6395947006</strong>, send a WhatsApp message to the same number, or simply walk in during our clinic hours. Priority appointment booking is available for Smile Card (Family Plan) members. We also offer emergency dental care for urgent cases.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faq;